import {FormModelType} from 'reactjs-use-form'

export const ACCOUNT_TYPE_SAVINGS = 'savings'
export const ACCOUNT_TYPE_CURRENT = 'current'

// Form state stores account type as lowercase to match the radio values.
// The backend `updatePaymentInformation` / `createReimbursementClaim` mutations
// expect Title-Case strings (e.g. "Savings" / "Current"), so callers must
// convert before sending.
export const toAccountTypeMutationValue = (
  value: string | undefined
): string => {
  const normalised = (value ?? ACCOUNT_TYPE_SAVINGS).toLowerCase()
  if (!normalised) return ''
  return normalised.charAt(0).toUpperCase() + normalised.slice(1)
}

// Country-specific bank fields are driven by the `bankFieldsSchema` GraphQL
// query rather than hard-coded per country. Their values are stored together
// as a JSON-stringified object under the single `localFields` form key (the
// `reactjs-use-form` library only supports string values).
export const EMPTY_LOCAL_FIELDS = '{}'

export const paymentModel: FormModelType = {
  country: {
    value: '',
    required: true,
  },
  accountHolderName: {
    value: '',
    required: true,
  },
  accountNumber: {
    value: '',
    required: true,
  },
  swiftCode: {
    value: '',
    required: false,
  },
  bankName: {
    value: '',
    required: true,
  },
  accountType: {
    value: ACCOUNT_TYPE_SAVINGS,
    required: true,
  },
  localFields: {
    value: EMPTY_LOCAL_FIELDS,
    required: false,
  },
}

export type PaymentFormValues = {
  country: string
  accountHolderName: string
  accountNumber: string
  swiftCode: string
  bankName: string
  accountType: string
  localFields: string
}
